import request from '@/utils/request'

export const getHomepageVersion = () =>
  request({
    url: '/api/ecwechat/ysh-homepage-version/get-one-v1',
  })
export const getModuleList = () =>
  request({
    url: '/api/ecservice/ec/homepage/module/list',
  })
export const getKingKongList = () =>
  request({
    url: '/api/ecservice/ec/homepage/kingkong/list',
  })
export const getTabsList = () =>
  request({
    url: '/api/ecservice/ec/homepage/tab',
  })
export const getBannerList = () =>
  request({
    url: '/api/ecservice/ec/homepage/banner/list',
  })
export const getChamberList = (params) =>
  request({
    url: '/api/ecservice/ec/homepage/extend/chamber/list',
    params,
  })
export const getOldChamberList = () =>
  request({
    url: '/api/ecservice/ec/homepage/chamber/chamber-list',
  })
export const getContactList = () =>
  request({
    url: '/api/ecservice/ec/homepage/contacts/list',
  })
export const getOldContactList = (params) =>
  request({
    url: '/api/ecservice/ec/homepage/contacts/homepage-contacts-list',
    params,
  })
export const getDemandHotList = (params) =>
  request({
    url: '/api/ecwechat/wechat/demandHot/getHotList',
    params,
  })
